/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_ShareInputs */

const en_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const es_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

const fr_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager`)
};

const de_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const ja_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有`)
};

const zh_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

const ar_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاركة`)
};

const id_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan`)
};

const it_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi`)
};

const ru_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделиться`)
};

const pt_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar`)
};

const ko_action_share = /** @type {(inputs: Action_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공유`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Action_ShareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_share = /** @type {((inputs?: Action_ShareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_ShareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_share(inputs)
	if (locale === "es") return es_action_share(inputs)
	if (locale === "fr") return fr_action_share(inputs)
	if (locale === "de") return de_action_share(inputs)
	if (locale === "ja") return ja_action_share(inputs)
	if (locale === "zh") return zh_action_share(inputs)
	if (locale === "ar") return ar_action_share(inputs)
	if (locale === "id") return id_action_share(inputs)
	if (locale === "it") return it_action_share(inputs)
	if (locale === "ru") return ru_action_share(inputs)
	if (locale === "pt") return pt_action_share(inputs)
	return ko_action_share(inputs)
});